module.exports = __webpack_public_path__ + "e34e86908f17a39975532dfce42daf1a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/adapter3.jpg
// module id = 163
// module chunks = 0